import type { OnFilterSheetClosed } from "./FilterSheetTopics";
import { submitAllAsAction } from "../filter/FilterTracking";
import type { TrackingLabels } from "../tracking/TrackingLabels";
import { eventQBus } from "../types/EventQBus";
import { forEachElement } from "../util/Utils";
import { createEventMergeId, deleteEventMergeId, submitEventTracking } from "../tracking/TrackingUtils";
import type { SheetCloseTypes } from "@otto-ec/global-pattern";
import { event } from "@otto-ec/global-resources/event";
import { events } from "../events";
import { updateNbaValuesStatusTo } from "../nextBestAction/NextBestActionComponent";
import { FilterTitle } from "../filter/FilterTitle";
import { FilterlistExpander } from "../filterlistExpander/FilterlistExpander";
import { getActiveSheet, getOcActiveSheet } from "../util/NonModuleFunctions";
import { Filter } from "../filter/Filter";
import type { OcSheetV1Events } from "@otto-ec/otto-components/sheet";
import { isActive } from "../toggle/Toggle";
import { getActiveVariation } from "../experiment/Experiments";
import { heureka } from "@otto-ec/heureka";

export function sanFoldoutDeprecated(closeType: SheetCloseTypes): TrackingLabels["san_Foldout"] {
  switch (closeType) {
    case "closedWithX":
      return "close_WithX";
    case "closedWithCurtainClick":
      return "close_filter_WithCurtainClick";
    case "closedWithDrag":
      return "close_filter_WithDrag";
    default:
      return "close_filter";
  }
}

export function sanFoldout(
  closeType: OcSheetV1Events["oc-sheet-close"]["detail"]["closeType"],
): TrackingLabels["san_Foldout"] {
  switch (closeType) {
    case "closedWithX":
      return "close_WithX";
    case "closedWithCurtainClick":
      return "close_filter_WithCurtainClick";
    case "closedWithDrag":
      return "close_filter_WithDrag";
    default:
      return "close_filter";
  }
}

function onFilterSheetOpened() {
  const isExpanderClosed = !FilterlistExpander.filterListExpander()?.expanded;
  const sheetDenseModeElem = isActive("HEUREKA_1913_MIGRATE_TO_OC_SHEET")
    ? getOcActiveSheet()?.querySelector("#heureka_filterTitlesDense")
    : getActiveSheet()?.getContent().querySelector("#heureka_filterTitlesDense");
  const filterTitles =
    sheetDenseModeElem && isExpanderClosed ? FilterTitle.factory.all(sheetDenseModeElem) : FilterTitle.factory.all();
  filterTitles?.forEach((filterTitle) => {
    filterTitle.filter?.updateFeatureStatus("loaded", "visible");
    if (filterTitle.fullMode || filterTitle.valuesAndTitle) {
      filterTitle.filter?.svelteFacets.forEach((facet) => {
        facet.updateFeatureStatus("loaded", "visible");
      });
    }
    if (filterTitle.onlyPopularValuesAndTitleMode) {
      filterTitle.filter?.svelteFacets.forEach((facet) => {
        facet.values.forEach((value) => value.updateStatus("loaded", "visible"));
      });
    }
  });
  submitAllAsAction("open", deleteEventMergeId());
}

function onFilterSheetClosed(event: OnFilterSheetClosed) {
  const filters = Filter.factory.all();
  filters?.forEach((filter) => {
    filter?.updateFeatureStatus("visible", "loaded");
    filter?.svelteFacets.forEach((facet) => {
      facet.updateFeatureStatus("visible", "loaded");
    });
  });
  updateNbaValuesStatusTo("visible");
  const { tracking } = event;
  const eventMergeId = deleteEventMergeId();

  if (tracking) {
    submitEventTracking(tracking, eventMergeId);
  }
}

function onFilterSectionLoaded() {
  forEachElement(".js_openFilterSheet", (elem) => {
    elem.addEventListener("click", onClickStartTsLabels.bind(elem), {
      passive: true,
    });
  });
}

function onClickStartTsLabels(this: HTMLElement) {
  const { tsLabels, tsSingle } = this.dataset;
  if (tsLabels) {
    submitEventTracking(JSON.parse(tsLabels), tsSingle ? undefined : createEventMergeId());
  }
}

/**
 *
 *
 *
 *
 *
 */
export function registerClickTracker(
  rootElement?: HTMLElement | keyof HTMLElementTagNameMap | string,
  options?: boolean | AddEventListenerOptions,
) {
  /*                                                                   */
  event.delegate(
    rootElement || (document as unknown as HTMLElement),
    "click",
    ".js_filterSheetAction",
    onClickStartTsLabels as (this: Element) => void,
    options as unknown as boolean,
  );
}

export function registerFilterSheetTracking() {
  eventQBus.on("ftfind.filterSheet.opened", onFilterSheetOpened);
  eventQBus.on("ftfind.filterSheet.closed", onFilterSheetClosed);

  eventQBus.on("ftfind.filterSheet.openedDetail", deleteEventMergeId);
  eventQBus.on("ftfind.filterSheet.closedDetail", deleteEventMergeId);

  eventQBus.on("ftfind.filterSheet.closedNavigation", deleteEventMergeId);

  if (getActiveVariation("e3911", "StatusQuo") === "Filterbar") {
    heureka.nextBestAction_loaded.on(onFilterSectionLoaded);
  } else {
    events.onFilterSectionLoaded(onFilterSectionLoaded);
  }
}
